module.exports = __webpack_public_path__ + "static/media/instagram-white.eb5c9653.svg";